var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-xs-center loader-wrapper"},[_c('lottie',{attrs:{"options":_vm.loaderOptions,"height":50,"width":50},on:{"animCreated":_vm.handleAnimation}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }